/* eslint-disable no-param-reassign */
import lodash from 'lodash';
import store from '../../core/store';
import product from './product';
import constRepository from './const-repository';

const OperationLogTypeList = [
    {
        name: '创建',
        value: 1,
        label: 'CREATE',
    },
    {
        name: '更新',
        value: 2,
        label: 'UPDATE',
    },
    {
        name: '删除',
        value: 3,
        label: 'DELETE',
    },
    {
        name: '查询',
        value: 4,
        label: 'QUERY',
    },
];
const OperationLogModuleList = [
    {
        name: '物模型',
        value: 1,
        label: 'PRODUCT',
    },
    {
        name: '物模型-属性',
        value: 2,
        label: 'PRODUCT_PROPERTY',
    },
    {
        name: '物模型-服务项',
        value: 3,
        label: 'PRODUCT_SERVICE_ITEM',
    },
    {
        name: '物模型-型号',
        value: 4,
        label: 'PRODUCT_MODEL',
    },
    {
        name: '物模型-配置项',
        value: 5,
        label: 'PRODUCT_CONFIG',
    },
    {
        name: '负载设备类型',
        value: 6,
        label: 'LOADED_DEVICE_TYPE',
    },
    {
        name: '动态库',
        value: 7,
        label: 'DLL_FILE',
    },
];
const OperationLogResultList = [
    {
        name: '成功',
        value: 1,
        label: 'SUCCESS',
    },
    {
        name: '失败',
        value: 2,
        label: 'FAILED',
    },
];
function deepDiffBetweenObjects(newData, oldData) {
    const changes = (obj, base) => lodash.transform(obj, (result, value, key) => {
        if (!lodash.isEqual(value, base[key])) {
            if (lodash.isArray(value)) {
                result[key] = lodash.difference(value, base[key]);
            } else if (lodash.isObject(value) && lodash.isObject(base[key])) {
                result[key] = changes(value, base[key]);
            } else {
                result[key] = value;
            }
        }
    });
    return changes(newData, oldData);
}
function setProductKeyNameAndValueName(diffObject, key) {
    if (key === 'productId') {
        diffObject.keyName = '产品ID';
    } else if (key === 'name') {
        diffObject.keyName = '产品名称';
    } else if (key === 'version') {
        diffObject.keyName = '版本';
    } else if (key === 'type') {
        diffObject.keyName = '产品类型';
        diffObject.oldValueName = store.state.metaData.productTypes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.productTypes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'productDeviceType') {
        diffObject.keyName = '产品设备类型';
        diffObject.oldValueName = store.state.metaData.productDeviceTypes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.productDeviceTypes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'addressType') {
        diffObject.keyName = '产品地址类型';
        diffObject.oldValueName = store.state.metaData.productAddressTypes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.productAddressTypes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'subAddressType') {
        diffObject.keyName = '子设备产品地址类型';
        diffObject.oldValueName = store.state.metaData.subProductAddressTypes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.subProductAddressTypes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'protocol') {
        diffObject.keyName = '产品控制协议类型';
        diffObject.oldValueName = store.state.metaData.productProtocols.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.productProtocols.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'useFrequency') {
        diffObject.keyName = '产品使用频率';
        diffObject.oldValueName = product.USE_FREQUENCY_OPTIONS.find((item) => item.value === diffObject.oldValue)?.label || '未知';
        diffObject.newValueName = product.USE_FREQUENCY_OPTIONS.find((item) => item.value === diffObject.newValue)?.label || '未知';
    } else if (key === 'driver') {
        diffObject.keyName = '中控内部驱动标识符';
    } else if (key === 'childrenCount') {
        diffObject.keyName = '可连接子设备数量';
    } else if (key === 'childrenCount') {
        diffObject.keyName = '可连接子设备数量';
    } else if (key === 'childrenString') {
        diffObject.keyName = '子节点产品ID';
    } else if (key === 'childrenCountLimit') {
        diffObject.keyName = '子设备数量限制';
    } else if (key === 'userVisible') {
        diffObject.keyName = '用户是否可见';
        diffObject.oldValueName = diffObject.oldValue ? '是' : '否';
        diffObject.newValueName = diffObject.newValue ? '是' : '否';
    } else if (key === 'strongCurrent') {
        diffObject.keyName = '强电设备';
        diffObject.oldValueName = diffObject.oldValue ? '是' : '否';
        diffObject.newValueName = diffObject.newValue ? '是' : '否';
    } else if (key === 'remark') {
        diffObject.keyName = '备注';
    } else if (key === 'propertyIds') {
        diffObject.keyName = '属性id';
        diffObject.oldValueName = diffObject.oldValue.join(',');
        diffObject.newValueName = diffObject.newValue.join(',');
    } else if (key === 'properties') {
        diffObject.keyName = '属性';
        diffObject.oldValueName = diffObject.oldValue.map((property) => property.identifier).join(',');
        diffObject.newValueName = diffObject.newValue.map((property) => property.identifier).join(',');
    } else if (key === 'regions') {
        diffObject.keyName = '产品关联区域';
        diffObject.oldValueName = diffObject.oldValue.map((region) => region.name).join(',');
        diffObject.newValueName = diffObject.newValue.map((region) => region.name).join(',');
    } else if (key === 'regionIdentifiers') {
        diffObject.keyName = '发布区域';
        diffObject.oldValueName = diffObject.oldValue.map((region) => region).join(',');
        diffObject.newValueName = diffObject.newValue.map((region) => region).join(',');
    } else if (key === 'loadedDeviceTypeIds') {
        diffObject.oldValueName = diffObject.oldValue.join(',');
        diffObject.newValueName = diffObject.newValue.join(',');
        diffObject.keyName = '负载类型id';
    } else if (key === 'loadedDeviceTypes') {
        diffObject.keyName = '负载类型';
        diffObject.oldValueName = `${diffObject.oldValue.map((loadedDevice) => `${loadedDevice.name}-(id:${loadedDevice.loadedDeviceTypeId})`)}`;
        diffObject.newValueName = `${diffObject.newValue.map((loadedDevice) => `${loadedDevice.name}-(id:${loadedDevice.loadedDeviceTypeId})`)}`;
    } else if (key === 'serviceIds') {
        diffObject.oldValueName = diffObject.oldValue.join(',');
        diffObject.newValueName = diffObject.newValue.join(',');
        diffObject.keyName = '服务id';
    } else if (key === 'services') {
        diffObject.keyName = '服务';
        diffObject.oldValueName = `${diffObject.oldValue.map((service) => service.identifier).join(',')}`;
        diffObject.newValueName = `${diffObject.newValue.map((service) => service.identifier).join(',')}`;
    } else if (key === 'configurationItemIds') {
        diffObject.oldValueName = diffObject.oldValue.join(',');
        diffObject.newValueName = diffObject.newValue.join(',');
        diffObject.keyName = '配置id';
    } else if (key === 'configurationItems') {
        diffObject.keyName = '配置';
        diffObject.oldValueName = `${diffObject.oldValue.map((configuration) => configuration.identifier).join(',')}`;
        diffObject.newValueName = `${diffObject.newValue.map((configuration) => configuration.identifier).join(',')}`;
    } else if (key === 'iconDownloadUrl') {
        diffObject.keyName = '产品图标';
        diffObject.type = 'image';
    } else if (key === 'internalModels') {
        diffObject.keyName = '关联产品型号';
        diffObject.oldValueName = `${diffObject.oldValue.map((model) => `${model.name}(:${model.identifier})`).join(',')}`;
        diffObject.newValueName = `${diffObject.newValue.map((model) => `${model.name}(:${model.identifier})`).join(',')}`;
    }
}
function diffProdutObject(oldData, newData) {
    const diffObject = deepDiffBetweenObjects(newData, oldData);
    const diffObjectList = lodash.keys(diffObject);
    const compareArray = [];
    diffObjectList.forEach((key) => {
        if (key === 'metadata') {
            const metaKeys = lodash.keys(diffObject.metaData);
            metaKeys.forEach((metaKey) => {
                const params = {
                    key: metaKey,
                    oldValue: oldData.metaData.metaKey,
                    newValue: newData.metaData.metaKey,
                };
                setProductKeyNameAndValueName(params, metaKey);
                compareArray.push(params);
            });
        } else {
            const params = {
                key,
                oldValue: oldData[key],
                newValue: newData[key],
            };
            setProductKeyNameAndValueName(params, key);
            compareArray.push(params);
        }
    });
    return compareArray;
}
function setProductPropertyKeyNameAndValueName(diffObject, key) {
    if (key === 'name') {
        diffObject.keyName = '属性名称';
    } else if (key === 'propertyType') {
        diffObject.keyName = '是否父节点';
        diffObject.oldValueName = constRepository.property.FILTER_NODES.find((item) => item.value === diffObject.oldValue)?.label || '未知';
        diffObject.newValueName = constRepository.property.FILTER_NODES.find((item) => item.value === diffObject.newValue)?.label || '未知';
    } else if (key === 'identifier') {
        diffObject.keyName = '属性标识符';
    } else if (key === 'encode') {
        diffObject.keyName = '属性定义唯一标识';
    } else if (key === 'accessMode') {
        diffObject.keyName = '属性定义唯一标识';
        diffObject.oldValueName = constRepository.property.getPropertyAccessModeName(diffObject.oldValue);
        diffObject.newValueName = constRepository.property.getPropertyAccessModeName(diffObject.newValue);
    } else if (key === 'type') {
        diffObject.keyName = '字段的存储类型';
        diffObject.oldValueName = store.state.metaData.dataPrimitiveTypes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.dataPrimitiveTypes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'editMode') {
        diffObject.keyName = '字段的编辑方式';
        diffObject.oldValueName = store.state.metaData.editModes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.editModes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'unit') {
        diffObject.keyName = '属性的单位';
    }
}
function diffProductPropertyObject(oldData, newData) {
    const diffObject = deepDiffBetweenObjects(newData, oldData);
    const diffObjectList = lodash.keys(diffObject);
    const compareArray = [];
    diffObjectList.forEach((key) => {
        if (key === 'description') {
            //
        } else if (key === 'type') {
            const typeKeys = lodash.keys(diffObject.type);
            typeKeys.forEach((typeKey) => {
                if (typeKey !== 'options') {
                    const params = {
                        key: typeKey,
                        oldValue: oldData.type[typeKey],
                        newValue: newData.type[typeKey],
                    };
                    setProductPropertyKeyNameAndValueName(params, typeKey);
                    compareArray.push(params);
                }
            });
        } else {
            const params = {
                key,
                oldValue: oldData[key],
                newValue: newData[key],
            };
            setProductPropertyKeyNameAndValueName(params, key);
            compareArray.push(params);
        }
    });
    return compareArray;
}
function setServiceItemKeyNameAndValueName(diffObject, key) {
    if (key === 'identifier') {
        diffObject.keyName = '服务标识符';
    } else if (key === 'defaultMessage') {
        diffObject.keyName = '服务描述';
    } else if (key === 'timeout') {
        diffObject.keyName = '超时时间';
        diffObject.oldValueName = `${diffObject.oldValue}ms`;
        diffObject.newValueName = `${diffObject.newValue}ms`;
    } else if (key === 'parameters') {
        diffObject.keyName = '参数项列表';
    } else if (key === 'name') {
        diffObject.keyName = '服务描述';
    }
}
function diffServiceItemObject(oldData, newData) {
    const diffObject = deepDiffBetweenObjects(newData, oldData);
    const diffObjectList = lodash.keys(diffObject);
    const compareArray = [];
    diffObjectList.forEach((key) => {
        if (key === 'description' || key === 'remark') {
            //
        } else {
            const params = {
                key,
                oldValue: oldData[key],
                newValue: newData[key],
            };
            setServiceItemKeyNameAndValueName(params, key);
            compareArray.push(params);
        }
    });
    return compareArray;
}
function setProductModelKeyNameAndValueName(diffObject, key) {
    if (key === 'identifier') {
        diffObject.keyName = '产品型号';
    } else if (key === 'name') {
        diffObject.keyName = '产品名称';
    } else if (key === 'productDtos') {
        diffObject.keyName = '关联物模型';
        diffObject.oldValueName = `${diffObject.oldValue.map((model) => model.name).join(',')}`;
        diffObject.newValueName = `${diffObject.newValue.map((model) => model.name).join(',')}`;
    }
}
function diffProductModelObject(oldData, newData) {
    const diffObject = deepDiffBetweenObjects(newData, oldData);
    const diffObjectList = lodash.keys(diffObject);
    const compareArray = [];
    diffObjectList.forEach((key) => {
        const params = {
            key,
            oldValue: oldData[key],
            newValue: newData[key],
        };
        setProductModelKeyNameAndValueName(params, key);
        compareArray.push(params);
    });
    return compareArray;
}
function setProductConfigKeyNameAndValueName(diffObject, key) {
    if (key === 'identifier') {
        diffObject.keyName = '配置标识符';
    } else if (key === 'encode') {
        diffObject.keyName = '配置项定义唯一标识';
    } else if (key === 'name') {
        diffObject.keyName = '配置项描述';
    } else if (key === 'defaultMessage') {
        diffObject.keyName = '配置项描述';
    } else if (key === 'remark') {
        diffObject.keyName = '备注';
    } else if (key === 'itemType') {
        diffObject.keyName = '产品配置项类型';
        diffObject.oldValueName = store.state.metaData.productConfItemTypes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.productConfItemTypes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'associatedPropertyIdentifier') {
        diffObject.keyName = '目标设备需要的属性';
    } else if (key === 'type') {
        diffObject.keyName = '字段的存储类型';
        diffObject.oldValueName = store.state.metaData.dataPrimitiveTypes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.dataPrimitiveTypes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'editMode') {
        diffObject.keyName = '字段的编辑方式';
        diffObject.oldValueName = store.state.metaData.editModes.find((item) => item.value === diffObject.oldValue)?.name || '未知';
        diffObject.newValueName = store.state.metaData.editModes.find((item) => item.value === diffObject.newValue)?.name || '未知';
    } else if (key === 'defaultValue') {
        diffObject.keyName = '默认值';
    } else if (key === 'min') {
        diffObject.keyName = '字符串长度最小值';
    } else if (key === 'max') {
        diffObject.keyName = '字符串长度最大值';
    } else if (key === 'options') {
        diffObject.keyName = '选项配置';
        diffObject.oldValueName = diffObject.oldValue.map((value) => `(值:${value.value},默认信息${value.description.defaultMessage})`).join('\n');
        diffObject.newValueName = diffObject.newValue.map((value) => `(值:${value.value},默认信息${value.description.defaultMessage})`).join('\n');
    }
}
function diffProductConfigObject(oldData, newData) {
    const diffObject = deepDiffBetweenObjects(newData, oldData);
    const diffObjectList = lodash.keys(diffObject);
    const compareArray = [];
    diffObjectList.forEach((key) => {
        if (key === 'description') {
            //
        } else if (key === 'type') {
            const typeKeys = lodash.keys(diffObject.type);
            typeKeys.forEach((typeKey) => {
                const params = {
                    key: typeKey,
                    oldValue: oldData.type[typeKey],
                    newValue: newData.type[typeKey],
                };
                setProductConfigKeyNameAndValueName(params, typeKey);
                compareArray.push(params);
            });
        } else {
            const params = {
                key,
                oldValue: oldData[key],
                newValue: newData[key],
            };
            setProductConfigKeyNameAndValueName(params, key);
            compareArray.push(params);
        }
    });
    return compareArray;
}
function setLoadedDeviceTypeKeyNameAndValueName(diffObject, key) {
    if (key === 'loadedDeviceTypeId') {
        diffObject.keyName = '负载类型ID';
    } else if (key === 'name') {
        diffObject.keyName = '负载类型名称';
    } else if (key === 'categories') {
        diffObject.keyName = '负载类型类别';
        diffObject.oldValueName = diffObject.oldValue.map((value) => constRepository.loadedDevice.CATEGORY_OPTION
            .find((item) => item.value === value)?.label || '未知').join(',');
        diffObject.newValueName = diffObject.newValue.map((value) => constRepository.loadedDevice.CATEGORY_OPTION
            .find((item) => item.value === value)?.label || '未知').join(',');
    } else if (key === 'detailPage') {
        diffObject.keyName = '设备详情页URL';
    } else if (key === 'detailPage') {
        diffObject.keyName = '设备详情页URL';
    } else if (key === 'propertyIds') {
        diffObject.keyName = '属性id';
        diffObject.oldValueName = diffObject.oldValue.join(',');
        diffObject.newValueName = diffObject.newValue.join(',');
    } else if (key === 'properties') {
        diffObject.keyName = '属性';
        diffObject.oldValueName = diffObject.oldValue?.map((property) => property.identifier).join(',');
        diffObject.newValueName = diffObject.newValue?.map((property) => property.identifier).join(',');
    } else if (key === 'regions') {
        diffObject.keyName = '产品关联区域';
        diffObject.oldValueName = diffObject.oldValue?.map((region) => region.name).join(',');
        diffObject.newValueName = diffObject.newValue?.map((region) => region.name).join(',');
    } else if (key === 'regionIdentifiers') {
        diffObject.keyName = '发布区域';
        diffObject.oldValueName = diffObject.oldValue.map((region) => region).join(',');
        diffObject.newValueName = diffObject.newValue.map((region) => region).join(',');
    } if (key === 'loadedDeviceTypeAliasRules') {
        diffObject.keyName = '别名规则';
        diffObject.oldValueName = diffObject.oldValue.map((rule) => (
            `${constRepository.loadedDevice.AliasRuleTypeTextObject[rule.aliasRule] || ''}-${constRepository.loadedDevice.ImageTypeLabel[rule.appType] || ''}-${rule.associateUniqueIdentifier || ''}-${rule.aliasName || ''}`
        )).join(',');
        diffObject.newValueName = diffObject.newValue.map((rule) => (
            `${constRepository.loadedDevice.AliasRuleTypeTextObject[rule.aliasRule] || ''}-${constRepository.loadedDevice.ImageTypeLabel[rule.appType] || ''}-${rule.associateUniqueIdentifier || ''}-${rule.aliasName || ''}`
        )).join(',');
        window.console.log(diffObject.oldValueName);
    }
}
function diffLoadedDeviceTypeObject(oldData, newData) {
    const diffObject = deepDiffBetweenObjects(newData, oldData);
    const diffObjectList = lodash.keys(diffObject);
    const compareArray = [];
    window.console.log(diffObjectList);

    diffObjectList.forEach((key) => {
        const params = {
            key,
            oldValue: oldData[key],
            newValue: newData[key],
        };
        setLoadedDeviceTypeKeyNameAndValueName(params, key);
        compareArray.push(params);
    });
    return compareArray;
}

function setDllFileKeyNameAndValueName(diffObject, key) {
    if (key === 'identifier') {
        diffObject.keyName = '服务标识符';
    } else if (key === 'defaultMessage') {
        diffObject.keyName = '服务描述';
    } else if (key === 'timeout') {
        diffObject.keyName = '超时时间';
        diffObject.oldValueName = `${diffObject.oldValue}ms`;
        diffObject.newValueName = `${diffObject.newValue}ms`;
    } else if (key === 'parameters') {
        diffObject.keyName = '参数项列表';
    } else if (key === 'name') {
        diffObject.keyName = '服务描述';
    }
}
function diffDllFileObject(oldData, newData) {
    const diffObject = deepDiffBetweenObjects(newData, oldData);
    const diffObjectList = lodash.keys(diffObject);
    const compareArray = [];
    diffObjectList.forEach((key) => {
        if (['model', 'hardVersion', 'soFilename', 'filename', 'path', 'sizeInBytes', 'md5', 'remark'].includes(key)) {
            const params = {
                key,
                oldValue: oldData[key],
                newValue: newData[key],
            };
            setDllFileKeyNameAndValueName(params, key);
            compareArray.push(params);
        }
    });
    return compareArray;
}
function transOperationLogDifferent(operationLogModule, oldData, newData) {
    let params = [];
    if (operationLogModule === 'PRODUCT') {
        params = diffProdutObject(oldData, newData);
    } if (operationLogModule === 'PRODUCT_PROPERTY') {
        params = diffProductPropertyObject(oldData, newData);
    } if (operationLogModule === 'PRODUCT_SERVICE_ITEM') {
        params = diffServiceItemObject(oldData, newData);
    } if (operationLogModule === 'PRODUCT_MODEL') {
        params = diffProductModelObject(oldData, newData);
    } if (operationLogModule === 'PRODUCT_CONFIG') {
        params = diffProductConfigObject(oldData, newData);
    } if (operationLogModule === 'LOADED_DEVICE_TYPE') {
        params = diffLoadedDeviceTypeObject(oldData, newData);
    } if (operationLogModule === 'DLL_FILE') {
        params = diffDllFileObject(oldData, newData);
    }
    const unUseUpdateKeys = ['updaterOpenId', 'lastModificationTime', 'configurationItemIds',
        'serviceIds', 'loadedDeviceTypeIds', 'regionIdentifiers', 'propertyIds', 'range', 'images', 'updaterName', 'version'];
    return params.filter((item) => !unUseUpdateKeys.includes(item.key));
}
export default {
    OperationLogTypeList,
    OperationLogModuleList,
    OperationLogResultList,
    getOperationLogTypeNameByLabel: (type) => OperationLogTypeList.find((item) => item.label === type)?.name || '未知',
    getOperationLogModuleNameByLabel: (module) => OperationLogModuleList.find((item) => item.label === module)?.name || '未知',
    getOperationLogResultNameByLabel: (result) => OperationLogResultList.find((item) => item.label === result)?.name || '未知',
    transOperationLogDifferent,
};
